module.exports = __webpack_public_path__ + "features-page-analyze-6c4b55e527ab325aa6120ef257092b3e.jpg";